import { ProductPageLayout } from '../components/ProductPageLayout';

export function GoogleAiUltraPage() {
    return <ProductPageLayout productId="google-ai-ultra" />;
}
